/* Снимок PlaceCatalog из сервера. Никаких запасных городов в браузере. */
(function () {
  'use strict';
  var node = document.getElementById('place-catalog-data');
  var data = { status: 'unavailable', cities: {}, aliases: {} };
  try {
    var parsed = node ? JSON.parse(node.textContent || '{}') : null;
    if (parsed && (parsed.status === 'live' || parsed.status === 'snapshot') && parsed.cities && parsed.aliases) data = parsed;
  } catch (_e) { /* явный unavailable */ }
  function city(slug) {
    return typeof slug === 'string' && Object.prototype.hasOwnProperty.call(data.cities, slug) ? data.cities[slug] : null;
  }
  function normalize(value) {
    return String(value).toLowerCase().replace(/ё/g, 'е').replace(/[\s.\u2010\u2011-]+/g, '');
  }
  function resolve(text) {
    var literal = String(text).toLowerCase().trim();
    if (/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(literal) && city(literal)) return literal;
    var key = normalize(text);
    if (!key) return null;
    var matched = null;
    var slugs = Object.keys(data.aliases);
    for (var i = 0; i < slugs.length; i++) {
      var aliases = data.aliases[slugs[i]];
      for (var j = 0; j < aliases.length; j++) {
        if (normalize(aliases[j]) === key && city(slugs[i])) {
          if (matched !== null && matched !== slugs[i]) return null;
          matched = slugs[i];
        }
      }
    }
    return matched;
  }
  function containsCity(text) {
    var words = String(text).toLowerCase().replace(/ё/g, 'е');
    var slugs = Object.keys(data.aliases);
    for (var i = 0; i < slugs.length; i++) {
      var aliases = data.aliases[slugs[i]];
      for (var j = 0; j < aliases.length; j++) {
        var alias = String(aliases[j]).toLowerCase().replace(/ё/g, 'е');
        var at = words.indexOf(alias);
        while (at !== -1) {
          if (!/[а-яa-z0-9]/i.test(words.charAt(at - 1)) && !/[а-яa-z0-9]/i.test(words.charAt(at + alias.length))) return true;
          at = words.indexOf(alias, at + 1);
        }
      }
    }
    return false;
  }
  window.BroniPlaces = {
    status: data.status, city: city,
    name: function (slug) { var row = city(slug); return row && typeof row.name === 'string' ? row.name : null; },
    resolve: resolve, containsCity: containsCity
  };
})();
